import { c as _c } from "react/compiler-runtime";
import { Banner } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useAppParams } from "@router/router-helper";
import { DateTimeUtils } from "@stellar/utils";
import { useMemo, useState } from "react";

/** Renders a banner that shows only for specific workspaces */
export function WorkspaceSpecificBanner(t0) {
  const $ = _c(7);
  const {
    title,
    text,
    variant,
    ids,
    deactivationDate
  } = t0;
  const {
    companyId
  } = useAppParams();
  const [isDismissed, setIsDismissed] = useState(false);
  let t1;
  bb0: {
    if (!deactivationDate) {
      t1 = false;
      break bb0;
    }
    t1 = DateTimeUtils.isDateOverdue(deactivationDate);
  }
  const hasDeactivationDatePassed = t1;
  if (!companyId || !ids.includes(companyId) || hasDeactivationDatePassed || isDismissed) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDismissed(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== text) {
    t3 = <div>{text}</div>;
    $[1] = text;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== title || $[5] !== variant) {
    t4 = <Box data-testid="workspace-specific-banner" component="div"><Banner title={title} variant={variant} onClose={t2}>{t3}</Banner></Box>;
    $[3] = t3;
    $[4] = title;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}